import { fireTrackingEvent } from '../../utils/fire-tracking-event.js';

const PRODUCT_OPTIONS_SELECTED_EVENT_NAME = "Product Options Selected";
const trackProductOptionsSelected = (data) => {
    // if isUpdated is false for an option, update field should always be "nochange" regardless what client passed through
    const productOptions = data.productOptions;
    const updatedProductOptions = productOptions.map(({ key, value, isUpdated, isVisible, update }) => {
        return {
            key,
            value,
            isUpdated,
            isVisible,
            update: !isUpdated ? "nochange" : update
        };
    });
    // Events that contain unexpected properties are ignored by tracking, so here by mapping manually each property
    // that is expected, the fireTrackingEvent will always send proper data. 
    fireTrackingEvent(PRODUCT_OPTIONS_SELECTED_EVENT_NAME, {
        category: data.category,
        core_product_id: data.core_product_id,
        docTrans: data.docTrans,
        label: data.label,
        list_price: data.list_price,
        name: data.name,
        pageDept: data.pageDept,
        pageName: data.pageName,
        pageSection: data.pageSection,
        pageStage: data.pageStage,
        price: data.price,
        product_id: data.product_id,
        productOptions: updatedProductOptions,
        productUpdate: data.productUpdate,
        sales_quantity: data.sales_quantity,
        variant: data.variant,
        // always set to 1 - for GA
        // https://vistaprint.atlassian.net/wiki/spaces/GA/pages/3393520037/Site-Wide+Product+Options+-+tracking+framework#Product-Options-Selected-event
        quantity: 1,
    });
};

export { PRODUCT_OPTIONS_SELECTED_EVENT_NAME, trackProductOptionsSelected };
//# sourceMappingURL=track-product-options-selected.js.map
